import React from 'react'
import { Button, Classes } from '@blueprintjs/core'
import { ThemedDialog } from 'ui-components'
import { TaskT } from 'ui-io/task-io/task-t'
import { taskEditMutation } from 'ui-io/queries/tasks/task-edit-mutation'
import { useMutation, useQueryClient } from 'react-query'
import toasts from '../../utils/toasts'
import useVerification from '../../components/use-verification'
import { TASKS_QUERY_FILTER } from 'ui-io/queries/tasks/task-query'

const FastlaneTaskDialog = ({
  task,
  isModalOpen,
  toggleModal,
}: {
  task: TaskT
  isModalOpen: boolean
  toggleModal: () => void
}) => {
  const queryClient = useQueryClient()
  const { validator, isValidated, handleOnReset } = useVerification({
    toValidate: task.id,
  })

  const mutation = useMutation(taskEditMutation, {
    onSuccess: () => {
      toasts.success(`Task updated successfully`)
      queryClient.refetchQueries([TASKS_QUERY_FILTER])
      toggleModal()
    },
    onError: (err) => {
      toasts.error(
        err instanceof Error ? err.message : 'Error in updating task',
      )
    },
  })

  const handleOnSubmit = (isFastlaneTask: boolean) => {
    const payload = {
      // configuration: {
      //   ...task._raw.configuration,
      //   system_priority: task.isFastlaneTask ? 0 : 1,
      // },
      info: task.info,
      priority: 1,
      isFastlaneTask: isFastlaneTask,
    }
    const { id } = task
    mutation.mutate({
      taskId: id,
      payload:payload,
    })
  }

  const isLoading = mutation.isLoading
  return (
    <>
      <ThemedDialog
        isOpen={isLoading || isModalOpen}
        title="Fastlane Task"
        onClose={toggleModal}
        onClosing={handleOnReset}
        icon={!task.isFastlaneTask ? 'rocket-slant' : 'fast-backward'}
      >
        <div className={Classes.DIALOG_BODY}>
          This action will change the Fastlane Status. If you are sure that this
          is what you want to do, please type in the last five characters of the
          task ID:
          {validator}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button onClick={toggleModal} disabled={isLoading}>
              Cancel
            </Button>
            <Button
              intent="primary"
              disabled={!isValidated}
              loading={isLoading}
              onClick={()=>handleOnSubmit(!task.isFastlaneTask?true:false)}
            >
              {!task.isFastlaneTask
                ? 'Add to Fastlane'
                : 'Remove from Fastlane'}
            </Button>
          </div>
        </div>
      </ThemedDialog>
    </>
  )
}

export default FastlaneTaskDialog
